export {
  DialogPersistent,
  type DialogPersistentProps,
} from '../../compositions/shared/DialogPersistent';
